import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const reviews = [
  "Urban Veera gave us a completely different perspective on property ownership. The team explained the model clearly and helped us understand the complete process.",
  "What attracted me was the ownership structure. Instead of simply buying an apartment, I was looking at a property model where the land and building were part of the ownership.",
  "The team was very clear about the property, construction and rental potential. We are happy with the way the project has been handled.",
  "Urban Veera helped us understand the property opportunity from a completely different angle. Their market knowledge and project approach gave us confidence.",
  "The biggest difference for us was understanding how the property itself could support the structure. The team guided us throughout the process.",
  "We trusted Urban Veera because they were transparent about the project and the ownership model. We are now experiencing the rental potential of our property.",
];

export const Reviews = () => (
  <section id="reviews" className="bg-paper py-20 md:py-28" data-testid="reviews-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal>
        <p className="font-spec text-[11px] uppercase tracking-[0.25em] text-amberdark">What our customers say</p>
        <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-navy sm:text-4xl" data-testid="reviews-headline">
          In their <span className="text-amber">own words.</span>
        </h2>
        <p className="mt-5 max-w-xl text-sm leading-relaxed text-steel" data-testid="reviews-privacy-note">
          Shared with permission. Names withheld for privacy — full references
          available on request when you speak with our team.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
        {reviews.map((r, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <figure
              data-testid={`review-card-${i}`}
              className={`group relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border border-border p-8 transition-shadow duration-300 hover:shadow-lift md:p-9 ${i % 2 === 0 ? "bg-white" : "bg-stone"}`}
            >
              <span className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-amber via-amber/40 to-transparent" aria-hidden="true" />
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-amber/10 text-amberdark transition-colors duration-300 group-hover:bg-amber group-hover:text-white">
                  <Quote size={20} />
                </span>
                <blockquote className="mt-6 font-display text-[15px] font-medium leading-relaxed tracking-tight text-navy md:text-base">
                  “{r}”
                </blockquote>
              </div>
              <figcaption className="mt-7 flex items-center gap-3 border-t border-border pt-5">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy font-spec text-[10px] font-bold uppercase tracking-wider text-amber">UV</span>
                <div>
                  <p className="text-sm font-bold text-navy">Urban Veera Customer</p>
                  <p className="font-spec text-[10px] uppercase tracking-[0.18em] text-steel">Name shared on request</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
